import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class ScrollFunc {
    constructor() {
        this.headerOffset = 0;
        this.toTopBtnGap = 35;
        this.init();
    }

    init() {
        this.smoothScroll();
        this.setNumForAdjustment();
        window.addEventListener('load', () => {
            this.onScroll();

            // テンプレート側のツールチップが3000ms後に出現するので待つ
            setTimeout(() => {
                this.refresh();
            }, 3100);
        });

        // リサイズ後に実行
        let timeoutID = 0;
        let delay = 200;

        window.addEventListener(
            'resize',
            () => {
                clearTimeout(timeoutID);
                timeoutID = setTimeout(() => {
                    this.refresh();
                    this.setNumForAdjustment();
                }, delay);
            },
            false
        );
    }

    refresh() {
        ScrollTrigger.refresh();
    }

    setNumForAdjustment() {
        if (window.innerWidth > 768) {
            this.headerOffset = 60;
        } else {
            this.headerOffset = 70;
        }
    }

    onScroll() {
        // 汎用フェードインに使用
        const revealElm = document.querySelectorAll('.js-scrollreveal');

        [...revealElm].forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: 'top 80%',
                //markers: true,
                onEnter: () => {
                    el.classList.add('-reveal');
                },
            });
        });

        // 個別の動きに使用
        const funcElm = document.querySelectorAll('.js-scrollfunc,.js-scrollfunc-up');

        [...funcElm].forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: 'top 80%',
                //markers: true,
                onEnter: () => {
                    el.classList.add('-scrollin');
                },
            });
        });

        const toTopBtn = document.querySelector('.js-totoplink');
        const that = this;

        ScrollTrigger.create({
            trigger: '.nm__footer',
            start: `top bottom-=${that.toTopBtnGap}`,
            onEnter: () => {
                toTopBtn.classList.add('-absolute');
            },
            onLeaveBack: () => {
                toTopBtn.classList.remove('-absolute');
            },
        });
    }

    smoothScroll() {
        const triggers = document.querySelectorAll('.js-smoothscroll');
        const pagetop = document.querySelectorAll('.js-pagetop');

        triggers.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const hash = el.getAttribute('href');
                gsap.to(window, { duration: 1, scrollTo: { y: hash, offsetY: this.headerOffset }, ease: 'circ.inOut' });
            });
        });

        pagetop.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                gsap.to(window, { duration: 1, scrollTo: { y: 0 }, ease: 'circ.inOut' });
            });
        });
    }
}
